<template>
  <el-row justify="start">
    <!--<el-autocomplete
      ref="headerSearchSelect"
      v-model.trim="search"
      class="header-search-select"
      :placeholder="$t('dashboard.search_content')"
      :fetch-suggestions="querySearchAsync"
      @select="handleSelect"
    />

    <i class="search-icon" @click.stop="searchWaybill" />
    <i class="search-icon search-icon2" @click.stop="searchReference" />-->
    <el-col>
      <div class="top-span">
        <el-input
          placeholder="搜索运单号/参考号/shipmentId[回车]"
          class="top-search"
          v-model="orderNo"
          @keyup.enter.native="search"
        >
          <i class="el-icon-search top-cursor" slot="suffix" @click="search()">
          </i>
          <i
            class="el-icon-document top-cursor"
            slot="suffix"
            @click="openMore"
          >
          </i>
        </el-input>
        <el-tooltip
          class="item"
          :hide-after="3000"
          effect="dark"
          v-model="topSearch"
          content="请输入单号"
          placement="bottom-start"
        >
          <!-- <el-divider class="top-search-m-tip"></el-divider> -->
        </el-tooltip>
        <el-input
          type="textarea"
          v-show="more"
          ref="moreInput"
          :rows="4"
          class="top-search-m"
          v-model="moreOrderNo"
        ></el-input>
      </div>
    </el-col>

  </el-row>
</template>

<script>
import {
  searchOrderByWaybillNo,
  clientQuickSearch,
  searchOrderByReferenceNo,
  searchLikeOrderToCustomer,
} from '@/api/waybill'
import { compileStr } from '@/utils'
export default {
  name: 'HeaderSearch',
  data() {
    return {
      //search: '',
      orderNo: "",
      moreOrderNo: "",
      more: false,
      topSearch: false,

    }
  },

  computed: {},
  watch: {},
  mounted() {},
  methods: {
    async search() {
      if (this.more) {
        if (this.moreOrderNo === "") {
          this.topSearch = true;
        }
        //let waybillNos = this.moreOrderNo.split(/[\s\n]/).filter(i => i != "")
        this.toSearch(this.moreOrderNo);

        this.more = false;
      } else {
        if (this.orderNo === "") {
          this.topSearch = true;
          return false;
        }

        this.toSearch(this.orderNo);
      }
    },
    openMore() {
      this.more = !this.more;
      console.log("more",this.more)
      if (this.more) {
        this.$nextTick((x) => {
          this.$refs.moreInput.focus();
        });
      }
    },
    async toSearch(val) {
      /*if(Array.isArray(val)){
        this.toWaybillList(val)
      }else{
        const data = await clientQuickSearch({ waybillNo: val })
        if (data.datas && data.datas.length > 0) {
          this.forwordUrl(data);
        } else if (data.code == 500) {
          this.$notify.error({
            title: "错误",
            message: "服务器错误，请联系系统管理员",
          });
        } else {
          //如果没有搜索到运单，开始搜客户,字符长度>=2,才会开启搜索
          //await this.fastSearchCustomer(val);
          this.$message('No Data')
          return
        }
      }*/
      const data = await clientQuickSearch({ waybillNo: val })
      if (data.datas && data.datas.length > 0) {
        this.forwordUrl(data);
      } else if (data.code == 500) {
        this.$notify.error({
          title: "错误",
          message: "服务器错误，请联系系统管理员",
        });
      } else {
        //如果没有搜索到运单，开始搜客户,字符长度>=2,才会开启搜索
        //await this.fastSearchCustomer(val);
        this.$message('No Data')
        return
      }
    },
    forwordUrl(data) {
      if (data.code == 500) {
        this.$notify.error({
          title: "错误",
          message: "服务器错误，请联系系统管理员",
        });
        return false;
      }
      if (data.datas.length === 0) {
        this.$notify.error({
          title: "错误",
          message: "没有查到对应的运单",
        });
        return false;
      }
      this.toPage(data, 1)
    },
    async querySearchAsync(queryString, cb) {
      if (!queryString) {
        return cb([])
      }
      const data = await searchLikeOrderToCustomer({ searchNo: queryString })
      if (data.datas && data.datas.length > 0) {
        let arr = []
        const arr2 = []
        if (data.datas.length > 10) {
          arr = data.datas.slice(0, 10)
        } else {
          arr = data.datas
        }
        for (const i of arr) {
          arr2.push({ value: i })
        }
        cb(arr2)
      } else {
        cb([])
      }
    },
    handleSelect(item) {
      const sw = this.search.slice(0, 3)
      if (
        sw.indexOf('ZX') > -1 ||
        sw.indexOf('AIR') > -1 ||
        sw.indexOf('FCL') > -1 ||
        sw.indexOf('LCL') > -1 ||
        sw.indexOf('TH') > -1 ||
        sw.indexOf('HWC') > -1 ||
        sw.indexOf('OT') > -1 ||
        sw.indexOf('HD') > -1
      ) {
        this.searchWaybill()
      } else {
        this.searchReference()
      }
    },
    async searchWaybill() {
      if (!this.search) {
        this.$message.error(this.$t('dashboard.waybill_no_required'))
        return
      }
      const data = await searchOrderByWaybillNo({ waybillNo: this.search })
      this.toPage(data, 0)
    },
    async searchReference() {
      if (!this.search) {
        this.$message.error(this.$t('dashboard.reference_no_required'))
        return
      }
      const data = await searchOrderByReferenceNo({
        referenceNo: this.search,
      })
      this.toPage(data, 1)
    },

    toPage(data, t) {
      // type 1：海空运、快递；2末端；3：海外仓
      const path = {}
      console.log("data:",data)
      if (data.datas.length === 0) {
        this.$message('No Data')
        return
      }
      if (data.datas.length === 1) {
        path.params = {
          id: compileStr(data.datas[0].id.toString()),
        };
        switch (data.type) {
          case 1:
            path.name = 'WaybillDetails'
            break
          case 2:
            path.name = 'WaybillHdDetail'
            break
          default:
            path.name = 'AbroadWaybillEdit'

            path.path = '/abroadWaybill/abroadWaybillEdit'
            path.query = {id: compileStr(data.datas[0].id.toString())}

            break
        }
        console.log('path', path);
        this.$router.push(path);
      } else {
        const obj = {
          'LCL':[],
          'ZX':[],
          'KD':[],
          'HWC':[],
          'TH':[],
          'HD':[]
        }
        data.datas.forEach((data) =>{
          if (data.shippingWay == "ZX" || data.shippingWay == "KT") {
            obj.ZX.push(data.waybillNo);
          } else if (data.shippingWay == "FCL" || data.shippingWay == "LCL") {
            obj.LCL.push(data.waybillNo);
          }else if (data.shippingWay == "99") {
            obj.KD.push(data.waybillNo);
          }else if (data.shippingWay == 'HD') {
            obj.HD.push(data.waybillNo);
          }else if (data.shippingWay == 'TH') {
            obj.TH.push(data.waybillNo);
          }else if (data.shippingWay == 'HWC') {
            obj.HWC.push(data.waybillNo);
          }
        });
        let path = {
          query: {},
          name: ''
        }
        if(obj.ZX.length!=0){
          path.name = 'WaybillList'
          path.query.waybillNos = obj.ZX.join(',')
          let routeData = this.$router.resolve(path)
          window.open(routeData.href)
        }
        if(obj.LCL.length!=0){
          path.name = 'WaybillList'
          path.query.waybillNos = obj.LCL.join(',')
          let routeData = this.$router.resolve(path)
          window.open(routeData.href)
        }
        if(obj.KD.length!=0){
          path.name = 'WaybillList'
          path.query.waybillNos = obj.KD.join(',')
          let routeData = this.$router.resolve(path)
          window.open(routeData.href)
        }
        if(obj.TH.length!=0){
          path.name = 'AbroadWaybillList'
          path.query.waybillNos = obj.TH.join(',')
          let routeData = this.$router.resolve(path)
          window.open(routeData.href)
        }
        if(obj.HWC.length!=0){
          path.name = 'AbroadWaybillList'
          path.query.waybillNos = obj.HWC.join(',')
          let routeData = this.$router.resolve(path)
          window.open(routeData.href)
        }
        if(obj.HD.length!=0){
          path.name = 'EndWaybillList'
          path.query.waybillNos = obj.HD.join(',')
          let routeData = this.$router.resolve(path)
          window.open(routeData.href)
        }
      }

    },
    //跳转运单列表
    toWaybillList(data){
      const obj = {
        'LCL':[],
        'ZX':[],
        'HD':[]
      }
      data.forEach(i=>{
        if(i.startsWith('ZX')||i.startsWith('KT')){
          obj.ZX.push(i)
        }else if(i.startsWith('LCL')){
          obj.LCL.push(i)
        }else if(i.startsWith('HD')){
          obj.HD.push(i)
        }
      })
      let path = {
        query: {},
        name: ''
      }
        if(obj.ZX.length!=0){
          path.name = 'WaybillList'
          path.query.waybillNos = obj.ZX.join(',')
          let routeData = this.$router.resolve(path)
          window.open(routeData.href)
        }
        if(obj.LCL.length!=0){
          path.name = 'AbroadWaybillList'
          path.query.waybillNos = obj.LCL.join(',')
          let routeData = this.$router.resolve(path)
          window.open(routeData.href)
        }
        if(obj.HD.length!=0){
          path.name = 'EndWaybillList'
          path.query.waybillNos = obj.HD.join(',')
          let routeData = this.$router.resolve(path)
          window.open(routeData.href)
        }

    }
  },
}
</script>

<style lang="scss" scoped>
.header-search {
  font-size: 0 !important;
  .search-icon {
    cursor: pointer;
    font-size: 18px;
    vertical-align: middle;
  }
  .header-search-select {
    font-size: 12px;
    transition: width 0.2s;
    width: 0;
    overflow: hidden;
    background: transparent;
    border-radius: 0;
    display: inline-block;
    vertical-align: middle;

    ::v-deep .el-input__inner {
      border-radius: 0;
      border: 0;
      padding-left: 0;
      padding-right: 0;
      box-shadow: none !important;
      border-bottom: 1px solid #d9d9d9;
      vertical-align: middle;
    }
  }
  &.show {
    .header-search-select {
      width: 150px;
      margin-left: 10px;
    }
  }

  .search-icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url('../../assets/images/waybill_pic.png');
  }

  .search-icon2 {
    background-image: url('../../assets/images/reference_pic.png');
  }
}
  .top-span{
    position: relative;
    .top-search-m{
      position: absolute;
      left: 0;
      top: 50px;
    }
  }
</style>
